<template>
  <form
    ref='formRef'
    :action='submitUrl'
    data-remote='true'
    method='post'
    accept-charset='UTF-8'
    class='lead-form'
    :class='{
      [i18nKey]: true
    }'
  >
    <input type='hidden' name='crm_lead[lead_type]' :value='leadType'>
    <SadIcon v-if='!isSoon' />
    <div class='headline'>{{ tp(`${i18nKey}.headline`) }}</div>
    <div class='subheadline'>{{ tp(`${i18nKey}.subheadline`) }}</div>

    <div class='b-input-v4'>
      <input
        :id='`crm_lead_client_${hash}`'
        ref='clientRef'
        name='crm_lead[client]'
        :placeholder="tp('form.name')"
        type='text'
        autocomplete='off'
      >
      <label :for='`crm_lead_client_${hash}`'>
        {{ tp('form.name') }}
      </label>
    </div>
    <!--div
      v-if='isSoon'
      class='b-input animated'
    >
      <input
        :id='`crm_lead_email_${hash}`'
        ref='emailRef'
        name='crm_lead[email]'
        :placeholder="tp('form.name')"
        type='text'
      >
      <label :for='`crm_lead_email_${hash}`'>
        {{ tp('form.email') }}
      </label>
    </div>
    <div
      v-else-->
    <div
      ref='phoneAreaRef'
      class='phone-area'
    >
      <div class='b-input-v4 country_code'>
        <select :id='`crm_lead_country_code_${hash}`'>
          <option
            v-for='option in countryCodes'
            :key='option[1]'
            :value='option[0]'
            v-html='option[1]'
          />
        </select>
        <label :for='`crm_lead_country_code_${hash}`'>
          {{ tp('form.country_code') }}
        </label>
      </div>
      <div class='b-input-v4 phone'>
        <input
          :id='`crm_lead_phone_${hash}`'
          ref='phoneRef'
          type='tel'
          autocomplete='off'
          :placeholder="tp('form.phone')"
          name='crm_lead[phone]'
        >
        <label :for='`crm_lead_phone_${hash}`'>
          {{ tp('form.phone') }}
        </label>
      </div>
    </div>
    <input type='submit' :value='tp("form.submit")' disabled>
  </form>
</template>

<script>
export default {
  name: 'StorageLeadForm'
};
</script>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import SadIcon from '@/../images/vue/storage_schema_boxes/lead_form/face-sad.svg?inline';

import ComposableForm from '@/views/composable_form';
import PhoneArea from '@/views/phone_area';
import track from '@/helpers/track';
import { t, prepared } from '@/helpers/i18n';

const props = defineProps({
  i18nKey: { type: String, required: true },
  submitUrl: { type: String, required: true },
  leadType: { type: String, required: true },
  countryCodes: { type: Array, required: true }
});
const tp = prepared('frontend.storage_schema_boxes.lead_form');

const isSoon = props.i18nKey === 'is_soon';

const hash = String(Math.floor(Math.random() * 1_000_000_000));

const form = ref(null);
const phoneArea = ref(null);

const formRef = ref(null);
const clientRef = ref(null);
const phoneRef = ref(null);
const emailRef = ref(null);
const phoneAreaRef = ref(null);

onMounted(() => {
  // if (isSoon) {
  //   form.value = new ComposableForm(formRef.value, {
  //     fields: [clientRef.value, emailRef.value]
  //   });
  // } else {
  phoneArea.value = new PhoneArea(phoneAreaRef.value, true, true);
  form.value = new ComposableForm(formRef.value, {
    fields: [clientRef.value],
    components: [phoneArea.value]
  });
  // }

  $(formRef.value).on('ajax:success', async () => {
    clear();

    track({ event: props.trackEvent });

    const { thanksModal } = await import(
        /* webpackChunkName: "modal" */
      '@/views/modal/thanks_modal'
    );
    thanksModal();
  });
});

onBeforeUnmount(() => {
  if (form.value) {
    form.value.destroy();
    form.value = null;
  }
});

const clear = () => {
  clientRef.value.value = '';
  if (emailRef.value) {
    emailRef.value.value = '';
  }
  if (phoneRef.value) {
    phoneRef.value.value = '';
  }
};
</script>

<style scoped lang='sass'>
@import 'app/packs/stylesheets/functions/rem'
@import 'app/packs/stylesheets/mixins/button_v4'
@import 'app/packs/stylesheets/mixins/responsive'
@import 'app/packs/stylesheets/mixins/typography'

.lead-form
  align-items: center
  display: flex
  flex-direction: column

  +lte_ipad
    gap: rem4(24px)

  +gte_laptop
    gap: 24px
    margin-left: auto
    margin-right: auto
    max-width: 395px

    // &.is_soon
    //   max-width: 358px

.headline
  +h4
  letter-spacing: -0.48px
  text-align: center

.subheadline
  +p4
  margin: 0
  max-width: auto
  text-align: center

.phone-area
  display: flex
  width: 100%

  +lte_ipad
    gap: rem4(16px)

  +gte_laptop
    gap: 16px

  .phone
    flex-grow: 1

  .country_code
    +lte_ipad
      width: rem4(126px)

    +gte_laptop
      width: 126px

input[type="submit"]
  +button_v4('primary', 'xl')
  width: 100%
</style>
